function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.7505 0.633301V3.16624H8.18028V21.2451H5.41108V3.16624H0V0.633301H13.7505Z",
  fill: "black"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M29.1879 13.6146L34.0579 21.2451H37.1772L31.9571 12.9498C33.064 12.4432 33.9707 11.5858 34.5353 10.5118C35.117 9.43184 35.4127 8.2224 35.3947 6.99735C35.4279 5.77819 35.0955 4.57679 34.4398 3.54623C33.7959 2.58635 32.8906 1.82861 31.8298 1.36157C30.6712 0.876767 29.4263 0.629101 28.1694 0.633355H22.6628V21.2135H25.4638V13.6146H29.1879ZM32.8167 7.1242C32.831 8.11136 32.4798 9.06927 31.8299 9.81544C30.9481 10.6811 29.7181 11.1006 28.4878 10.9553H25.464V3.16649H28.647C29.5073 3.13653 30.3548 3.38056 31.066 3.86305C31.6379 4.21695 32.1004 4.72092 32.4029 5.31949C32.6757 5.88237 32.8172 6.4993 32.8167 7.1242Z",
  fill: "black"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M94.1842 0.633234V21.9099L78.874 6.55397V21.245H76.073V0L91.2558 15.5459V0.633234H94.1842Z",
  fill: "black"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M108.763 0.632991H103.097L103.065 21.2448H109.75C111.526 21.2461 113.275 20.811 114.842 19.9783C116.388 19.1624 117.685 17.9487 118.598 16.4638C119.543 14.8623 120.028 13.0332 119.999 11.1763C120.01 9.40919 119.607 7.66381 118.821 6.0788C118.007 4.43629 116.722 3.07023 115.129 2.15275C113.186 1.07827 110.984 0.552734 108.763 0.632991ZM113.314 17.6669C112.041 18.2635 110.648 18.5666 109.24 18.5535H105.866V3.16588H109.495C110.821 3.19305 112.121 3.54077 113.283 4.17905C114.448 4.78484 115.427 5.69288 116.115 6.80697C116.839 8.06867 117.202 9.50277 117.166 10.9547C117.2 12.3822 116.848 13.7928 116.147 15.039C115.484 16.1739 114.499 17.0883 113.314 17.6669Z",
  fill: "black"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M60.2589 12.5381L44.7377 12.5381V9.40358L60.2589 9.40358V12.5381Z",
  fill: "#FFCB6F"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M66.6497 3.58203L44.7375 3.58203V0.447524L66.6497 0.447524V3.58203Z",
  fill: "#FFB917"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M55.6708 21.3521L44.7147 21.3521V18.2175H55.6708V21.3521Z",
  fill: "#FEDEA7"
});

const SvgComponent = props => React.createElement("svg", _extends({
  width: 120,
  height: 22,
  viewBox: "0 0 120 22",
  fill: "none"
}, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);

export default __webpack_public_path__ + "static/media/TrendLogoBlack.7a3f6657.svg";
export { SvgComponent as ReactComponent };